/**
 * Въртящият се пръстен „работи се": обвивката се върти, а дъгата „диша"
 * (`posRingDash` в index.css). Малкото копие на някогашния голям спинър в
 * модала „Закрий" — ползват го „Закрива се" на картата на масата в списъка и
 * масата/плочката в процес на закриване в режим „Схема". Размерът е от
 * `className`, цветовете — `trackClass` (бледият кръг) и `arcClass` (дъгата).
 */
const BusyRing = ({
  className,
  strokeWidth = 9,
  trackClass = "stroke-pos-accent/25",
  arcClass = "stroke-pos-accent",
}: {
  className: string;
  // Дебелината във viewBox 104 — ~1.3px при 16px пръстен.
  strokeWidth?: number;
  trackClass?: string;
  arcClass?: string;
}) => (
  <span className={`block shrink-0 animate-[spin_2.6s_linear_infinite] ${className}`}>
    <svg viewBox="0 0 104 104" className="block h-full w-full">
      <circle cx="52" cy="52" r="43" fill="none" strokeWidth={strokeWidth} className={trackClass} />
      <circle
        cx="52"
        cy="52"
        r="43"
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        className={`${arcClass} animate-[posRingDash_2.2s_ease-in-out_infinite]`}
      />
    </svg>
  </span>
);

export default BusyRing;
